var render, staticRenderFns
import script from "./ib-visibility.vue?vue&type=script&lang=js&"
export * from "./ib-visibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db7d5e1a')) {
      api.createRecord('db7d5e1a', component.options)
    } else {
      api.reload('db7d5e1a', component.options)
    }
    
  }
}
component.options.__file = "src/components/misc/ib-visibility.vue"
export default component.exports